import React from "react";
import { CharacterSheet } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const Destino: React.FC<Props> = ({ character, onChange }) => {
  const updateField = (field: keyof NonNullable<CharacterSheet["destino"]>, value: any) => {
    if (!character.destino) {
      character.destino = {
        nivel: 0,
        encontrosSorte: 0,
        tribulacoesSubitas: 0,
      };
    }
    onChange({
      ...character,
      destino: {
        ...character.destino,
        [field]: value,
      },
    });
  };

  const toggleDestino = () => {
    if (character.destino) {
      onChange({ ...character, destino: undefined });
    } else {
      onChange({
        ...character,
        destino: {
          nivel: 0,
          encontrosSorte: 0,
          tribulacoesSubitas: 0,
        },
      });
    }
  };

  if (!character.destino) {
    return (
      <div className="section">
        <h2>Destino</h2>
        <button type="button" onClick={toggleDestino} className="btn-add">
          + Adicionar Destino
        </button>
      </div>
    );
  }

  return (
    <div className="section">
      <h2>Destino</h2>
      <button type="button" onClick={toggleDestino} className="btn-remove">
        Remover Destino
      </button>
      <div className="form-grid">
        <div className="form-group">
          <label>Nível de Destino</label>
          <input
            type="number"
            value={character.destino.nivel}
            onChange={(e) => updateField("nivel", parseInt(e.target.value) || 0)}
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Encontros de Sorte</label>
          <input
            type="number"
            value={character.destino.encontrosSorte}
            onChange={(e) => updateField("encontrosSorte", parseInt(e.target.value) || 0)}
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Tribulações Súbitas</label>
          <input
            type="number"
            value={character.destino.tribulacoesSubitas}
            onChange={(e) => updateField("tribulacoesSubitas", parseInt(e.target.value) || 0)}
            min="0"
          />
        </div>
      </div>
    </div>
  );
};
